import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

export function usePost(postId) {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!postId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = onSnapshot(
      doc(db, 'posts', postId),
      (doc) => {
        if (doc.exists()) {
          setPost({ id: doc.id, ...doc.data() });
        } else {
          setError('Post not found');
          setPost(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching post:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [postId]);

  return { post, loading, error };
}
